var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "dialog",
      attrs: {
        title: _vm.titleDialog,
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "600px",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onHandleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "contents" },
        [
          _c(
            "el-form",
            {
              ref: "refForm",
              attrs: {
                "label-width": "150px",
                model: _vm.formData,
                rules: _vm.formRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "属性名称", prop: "field_key" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.titleDialog == "添加属性" ? false : true,
                      placeholder: "请输入",
                      clearable: "",
                      maxlength: "10",
                    },
                    on: { input: _vm.handleInput },
                    model: {
                      value: _vm.formData.field_key,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "field_key", $$v)
                      },
                      expression: "formData.field_key",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "属性值", prop: "field_map" } },
                [
                  _vm.formData.field_map.length
                    ? _c(
                        "div",
                        { staticClass: "tag-list" },
                        _vm._l(_vm.formData.field_map, function (child, index) {
                          return _c("div", { key: index, staticClass: "tag" }, [
                            _c(
                              "div",
                              { staticClass: "name" },
                              [
                                _vm.system_type ==
                                _vm.PROPERTY_TYPE_ENUM[0].value
                                  ? _c("el-input", {
                                      attrs: {
                                        placeholder: "",
                                        clearable: "",
                                        maxlength: "10",
                                      },
                                      model: {
                                        value: child.name,
                                        callback: function ($$v) {
                                          _vm.$set(child, "name", $$v)
                                        },
                                        expression: "child.name",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.system_type ==
                                _vm.PROPERTY_TYPE_ENUM[1].value
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          clearable: "",
                                          filterable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: child.name,
                                          callback: function ($$v) {
                                            _vm.$set(child, "name", $$v)
                                          },
                                          expression: "child.name",
                                        },
                                      },
                                      _vm._l(
                                        _vm.options,
                                        function (itenchild, i) {
                                          return _c("el-option", {
                                            key: i,
                                            attrs: {
                                              label: itenchild,
                                              value: itenchild,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "icon-wrap",
                                on: {
                                  click: function ($event) {
                                    return _vm.onDelete(index)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "icon el-icon-delete" })]
                            ),
                            _c("div", { staticClass: "icon-wrap" }, [
                              index === _vm.formData.field_map.length - 1
                                ? _c("i", {
                                    staticClass: "icon el-icon-plus",
                                    on: { click: _vm.onCreate },
                                  })
                                : _vm._e(),
                            ]),
                            _c("div", { staticClass: "icon-wrap" }, [
                              _c("i", {
                                staticClass: "icon el-icon-rank",
                                on: {
                                  click: function ($event) {
                                    return _vm.onRemove(index)
                                  },
                                },
                              }),
                            ]),
                          ])
                        }),
                        0
                      )
                    : _c(
                        "div",
                        { staticClass: "tag-add", on: { click: _vm.onCreate } },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(" 添加属性值 "),
                        ]
                      ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否必填", prop: "is_must" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formData.is_must,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "is_must", $$v)
                        },
                        expression: "formData.is_must",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            label: 1,
                            disabled:
                              _vm.titleDialog == "编辑属性" &&
                              _vm.cidType == 2 &&
                              _vm.formData.field_key == "包装方式"
                                ? true
                                : false,
                          },
                        },
                        [_vm._v("是")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: {
                            label: 0,
                            disabled:
                              _vm.titleDialog == "编辑属性" &&
                              _vm.cidType == 2 &&
                              _vm.formData.field_key == "包装方式"
                                ? true
                                : false,
                          },
                        },
                        [_vm._v("否")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "是否显示/隐藏", prop: "is_show" } },
                [
                  _c("el-switch", {
                    staticClass: "switch",
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      width: 50,
                    },
                    model: {
                      value: _vm.formData.is_show,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "is_show", $$v)
                      },
                      expression: "formData.is_show",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex a-center" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "是否可编辑", prop: "product_edit_type" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.product_edit_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "product_edit_type", $$v)
                            },
                            expression: "formData.product_edit_type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("可编辑"),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("不可编辑"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "23px",
                        "margin-left": "20px",
                      },
                    },
                    [
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content:
                              "控制对已发售的商品下架后，是否可编辑该属性的属性值",
                            placement: "top",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-question",
                            staticStyle: { cursor: "pointer" },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: { label: "是否在分类页面显示", prop: "is_searchable" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.formData.is_searchable,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "is_searchable", $$v)
                        },
                        expression: "formData.is_searchable",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("显示")]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v("不显示"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onHandleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loadingSubmit },
              on: { click: _vm.onHandleSubmit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }